export default __webpack_public_path__ + "static/media/death.4670ac6e.png";